<div class="body">

    <div class="left-column" @list>

        <ng-container *ngIf="(service.mails$|async)?.length > 0; else noMails">

            <div class="mail-entry-wrapper" [class.active]="(service.currentMailId$|async) === mail.messageId" *ngFor="let mail of (service.mails$|async)" (click)="eMailClicked(mail)">

                <app-mail-list-entry [currentMail]="mail"></app-mail-list-entry>
    
            </div>

        </ng-container>

    </div>

    <div class="right-column">

        <div class="hint" *ngIf="(service.mailsLoading$|async) || (converting$|async) || !service.convertedBody; else currentMailContentView">
            <span class="spacer"></span>
            <span class="text">

                <ng-container *ngIf="(service.mailsLoading$|async)">

                    Lade E-Mails ...

                </ng-container>

                <ng-container *ngIf="(converting$|async)">

                    Konvertiere ausgewählte E-Mail - bitte warten ...

                </ng-container>

                <ng-container *ngIf="!(service.mailsLoading$|async) && !(converting$|async)">

                    Keine E-Mail ausgewählt

                </ng-container>

                
            </span>
            <span class="spacer"></span>
        </div>

        <ng-template #currentMailContentView>
            
            <quill-view [content]="service.convertedBody" format="html" #quillComponent class="quill-note-view"></quill-view>

        </ng-template>

    </div>
</div>

<div class="bottom-row">

    <div *ngIf="!(service.mailsLoading$|async); else mailsCheckingHint" class="control-row">

        <div class="control-row-inner">
            
            <mat-icon class="control primary" (click)="recoverSeenMail()" matTooltip="Abgearbeitete E-Mail wiederherstellen">
                switch_access_shortcut_add
            </mat-icon>

            <mat-icon class="control primary" (click)="service.checkForNewMails()" matTooltip="Auftragspostfach erneut abrufen">
                wifi_protected_setup
            </mat-icon>

            <div class="counter">
                {{(service.mails$|async)?.length}} E-Mail(s)
            </div>
            
            <div  *ngIf="service.convertedBody" class="current-mail">

                <div class="transmitter">
                    <span *ngIf="(service.currentMail$|async)?.transmitter">
                        Von: {{ (service.currentMail$|async)?.transmitter?.name }} {{ (service.currentMail$|async)?.transmitter?.address }}
                    </span>
                </div>

                <div class="subject">
                    Betreff: {{(service.currentMail$|async)?.subject}}
                </div>

            </div>

            <mat-icon  *ngIf="service.convertedBody" class="control success" (click)="createIssue()">
                add
            </mat-icon>

            <mat-icon  *ngIf="service.convertedBody" class="control danger" (click)="removeMail()"
                matTooltip="Mail aus Eingang entfernen">
                delete_forever
            </mat-icon>

            <mat-icon  *ngIf="service.convertedBody" class="control primary2" (click)="linkToIssue()"
                matTooltip="Bestehendem {{(service.account$|async) === 'assignment'? 'Vorgang': 'Ticket'}} zuordnen">
                call_merge
            </mat-icon>

            <mat-icon  *ngIf="service.convertedBody" class="control primary2" (click)="answerMail()"
                matTooltip="Absender antworten">
                send
            </mat-icon>
            
            <div  *ngIf="service.convertedBody">
                <div class="control-container" matTooltip="Anhänge" [matMenuTriggerFor]="attachementsMenu">
                    <mat-icon class="control neutral">
                        attach_file
                    </mat-icon>
                    <span class="attachement-counter">
                        {{(service.currentMail$|async)?.mailAttachements.length}}
                    </span>
                </div>
                <mat-menu #attachementsMenu="matMenu">

                    <div *ngIf="(service.currentMail$|async)?.mailAttachements.length == 0" class="no-attachements-hint">
                        Die Mail enthält keine Anhänge
                    </div>

                    <button *ngFor="let attachement of (service.currentMail$|async)?.mailAttachements" mat-menu-item (click)="openFile(attachement)">
                        <span class="file-icon fiv-sqo" [ngClass]="attachement.type|fileType"></span>
                        <span>{{attachement.name}}</span>
                    </button>

                </mat-menu>
            </div>
            <span class="spacer"></span>
            <mat-icon *ngIf="service.convertedBody" class="control neutral" (click)="service.clearCurrentMail()"
                matTooltip="Mail schließen">
                clear
            </mat-icon>
        </div>

    </div>

    <ng-template #mailsCheckingHint>
        <div class="hint">
            <div class="spacer"></div>
            <div class="spinner-wrapper">
                <mat-spinner [diameter]="20"></mat-spinner>
            </div>
            <span class="text">
                Mails werden abgerufen
            </span>
            <div class="spacer"></div>
        </div>
    </ng-template>

</div>

<ng-template #noMails>

    <div class="no-mails-hint">

        keine Mails im Postfach

    </div>

</ng-template>
